import {Component, Input, OnInit} from '@angular/core';

/**
 * Component for showing an helptext that can be toggled so see/hide
 */
@Component({
    selector: 'app-helptext',
    templateUrl: './helptext.component.html',
    standalone: false
})
export class HelptextComponent implements OnInit {
  /**
   * The icon for the toggle
   */
  @Input() icon: string;

  /**
   * visible text of the toggle button
   */
  @Input() buttontext: string;

  /**
   * the actual help text
   */
  @Input() helptext: string = null;

  /**
   * sho the helptext downworads instead of upwards
   */
  @Input() down: boolean = false;

  /**
   * open the helptext to the left instead of right
   */
  @Input() left: boolean = false;

  /**
   * id for the helptext to make aria-controls reference
   */
  @Input() helptextId: string;

  /**
   * textkey for the helptext
   */
  textkey: string;

  /**
   * toggles when the helptext is opened/closed.
   */
  open: boolean;

  /**
   * show/hide the text
   */
  toggleText(): void {
    if(!this.helptext) {
      return;
    }

    this.open = !this.open;
  }

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.textkey = this.buttontext;
  }

}
